const rootReducers = {};

export default rootReducers;
